import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1918a774"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "menuWithTabsContent" }

import { BtnsForTabsMenuType } from '@/types';
import { computed, onMounted, ref, Ref, watch } from 'vue';
import AnnouncementList from '@/components/ProfileComponents/MyAnnouncements/AnnouncementList/AnnouncementList.vue';
import { useRoute, useRouter } from 'vue-router';


export default /*#__PURE__*/_defineComponent({
  __name: 'MyAnnouncements',
  setup(__props) {

const componentBtns: BtnsForTabsMenuType[] = [
  { id: 'active', title: 'Активные' },
  { id: 'drafts', title: 'Черновики' },
  { id: 'archive', title: 'Архив' },
];

const activeComponentBtnId: Ref<undefined | number | string> = ref(undefined);
const router = useRouter();
const route = useRoute();
const changeActiveBtn = (btnId: number | string) => {
  router.push({ params: { id: 'myAnnouncements' }, query: { menuItem: btnId } });
  activeComponentBtnId.value = btnId;
};
const activeBtnId = computed(() => {
  return route?.query.menuItem;
});

onMounted(() => {
  if (activeBtnId.value && !!componentBtns.find(el => el.id === activeBtnId.value)) {
    changeActiveBtn(`${activeBtnId.value}`);
  } else {
    changeActiveBtn(componentBtns[0].id);
  }
});
watch(
  () => activeBtnId.value,
  () => {
    if (activeBtnId.value && !!componentBtns.find(el => el.id === activeBtnId.value)) {
      activeComponentBtnId.value = `${activeBtnId.value}`;
    }
  },
);

return (_ctx: any,_cache: any) => {
  const _component_base_menu_with_tabs = _resolveComponent("base-menu-with-tabs")!

  return (_openBlock(), _createBlock(_component_base_menu_with_tabs, {
    activeComponent: activeComponentBtnId.value,
    componentBtns: componentBtns,
    bgColor: "#fff",
    withRadius: "",
    onChangeActiveBtn: _cache[0] || (_cache[0] = ($event: any) => (changeActiveBtn($event)))
  }, {
    content: _withCtx((contentProps) => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(AnnouncementList, { type: activeComponentBtnId.value }, null, 8, ["type"])
      ])
    ]),
    _: 1
  }, 8, ["activeComponent"]))
}
}

})